
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.facet-wrapper-button.inactive, .facet-wrapper-button.active {
  border-style: none;
  background-color: var(--blue-responsible-main);
  color: var(--neutral-white);
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}@media (min-width: 1024px) {.facet-wrapper-button.inactive, .facet-wrapper-button.active {
    display: none;
  }
}.facet-wrapper-button.inactive, .facet-wrapper-button.active {
  cursor: pointer;
  border-radius: 0.5rem;
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  font-weight: var(--fw-semibold);
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
  outline: 2px solid transparent;
  outline-offset: 2px;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  line-height: 1.5;
  padding: 1rem !important;
}.facet-wrapper-button.inactive:hover, .facet-wrapper-button.inactive:focus, .facet-wrapper-button.active:hover, .facet-wrapper-button.active:focus {
  background-color: var(--blue-responsible-darken-2);
}.facet-wrapper-button.inactive:hover, .facet-wrapper-button.inactive:focus, .facet-wrapper-button.active:hover, .facet-wrapper-button.active:focus {
  color: var(--neutral-white);
}.facet-wrapper-button.inactive:focus, .facet-wrapper-button.active:focus {
  outline-offset: 2px;
  outline-width: 3px;
  outline-style: solid;
  outline-color: #4299e1;
}.facet-wrapper-button.inactive:not(.mobile), .facet-wrapper-button.active:not(.mobile) {
  display: none;
}

.facet-wrapper-icon.inactive, .facet-wrapper-icon.active {
  width: auto;
  background-color: var(--neutral-transparent);
}

idb-icon{
  font-size:1.25rem;
}

.facet-wrapper-content.mobile.active {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 10;
  overflow: hidden;
  padding: 1.5rem;
  background:rgba(0, 0, 0, 0.7);
}

.facet-wrapper-content.mobile .inner {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  border-radius: 0.5rem;
  background-color: var(--neutral-white);
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.facet-wrapper-content-label {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

@media (min-width: 1024px) {.facet-wrapper-content-label {
    display: none;
  }
}

.facet-wrapper-collapse-button {
  cursor: pointer;
  border-width: 0px;
  background-color: var(--neutral-transparent);
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 1024px) {.facet-wrapper-collapse-button {
    display: none;
  }
}

.facet-wrapper-collapse-button {
  margin-left: auto;
  width: 100%;
  border-radius: 9999px;
  background-color: var(--blue-responsible-main);
  color: var(--neutral-white);
  width:44px;
  height:44px;
}

.facet-wrapper-collapse-button:hover, .facet-wrapper-collapse-button:focus {
  background-color: var(--blue-responsible-darken-2);
}

.facet-wrapper-collapse-button:hover, .facet-wrapper-collapse-button:focus {
  color: var(--neutral-white);
}

.facet-wrapper-collapse-button:focus {
  outline-offset: 2px;
  outline-width: 3px;
  outline-style: solid;
  outline-color: #4299e1;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
`;